module.exports = __webpack_public_path__ + "img/umbriel.e3c3c666.png";